<template>
  <div>
    <el-row class="container" style="margin-top:15px;" :gutter="20">
      <!-- Columna Filtros -->
      <el-col class="container_col_1" :span="6">
        <!-- Header filtros-->
        <el-row style="margin-bottom:15px;">
          <el-col :span="16">
            <div class="title">{{ $t('NAVBAR_archivos') }}</div>
          </el-col>
          <el-col :span="8" class="btn-nuevo">
            <router-link class="btn-nuevo" :to="{ name: 'Nuevo Archivo'}">
              <el-button type="primary" icon="Plus" size="small" round>{{ $t('GENERAL_nuevo') }}</el-button>
            </router-link>
          </el-col>
        </el-row>
        <!-- Filtros -->
        <el-row>
          <el-collapse v-model="activeNames" style="margin-bottom: 5px;">
            <el-collapse-item :title="$t('GENERAL_Busqueda_Simple')" name="1">
              <div class="filters">
                <div class="filters_item">
                  <div class="label">{{ $t('ARCHIVOS_nombre') }}</div>
                  <el-input
                    :placeholder="$t('ARCHIVOS_nombre')"
                    size="small"
                    v-model="filtros.nombre"
                    @input="getArchivosDelayed"                  
                  />
                </div>
                <div class="filters_item">
                  <div class="label">{{$t('ARCHIVOS_tipo')}}</div>
                  <el-select v-model="filtros.esArchivo" class="seleccionador" size="small"
                    :placeholder="$t('GENERAL_seleccione')"
                    @change="seleccionarCarpeta" 
                  >
                    <el-option
                      :label="$t('ARCHIVOS_archivo')"
                      :value="true">
                    </el-option>
                    <el-option
                      :label="$t('ARCHIVOS_carpeta')"
                      :value="false">
                    </el-option>
                  </el-select>
                </div>
                <div v-if="!filtros.esArchivo" class="filters_item">
                  <div class="label">{{$t('ARCHIVOS_carpeta')}}</div>
                  <el-select v-model="filtros.idCarpeta" class="seleccionador" size="small"
                    :placeholder="$t('GENERAL_seleccione')"
                    @change="seleccionarCarpeta"
                  >
                    <el-option
                      :label="$t('GENERAL_seleccione')"
                      :value="-1">
                    </el-option>
                    <el-option
                      v-for="carpeta in carpetas"
                      :key="carpeta.Id"
                      :label="carpeta.Nombre"
                      :value="carpeta.Id">
                    </el-option>
                  </el-select>
                  </div>
                <!-- <div class="label">
                  {{$t('ARCHIVOS_incluir_archivos_publicos')}}
                  <el-switch
                    class="switch"
                    v-model="filtros.incluirPublicos"
                    size="small"
                    @input="getArchivosDelayed"                
                  />
                </div> -->
              <div class="clearFilters" @click="cleanFilters">{{$t('GENERAL_clean_filters')}}</div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </el-row>
      </el-col>

      <!-- Resultados de búsqueda --> 
      <el-col class="container_col_2" :span="17">
        <!-- Header resultados de búsqueda -->
        <el-row style="margin-bottom:15px;">
          <el-col :xs="8" :sm="12"  :md="10" :lg="16" :xl="16">
             <div class="sub-title">{{$t('GENERAL_resultado')}}</div>
          </el-col>
          <el-col :xs="16" :sm="12"  :md="14" :lg="8" :xl="8" class="pagination_container">
            <el-pagination         
            background
            small
            layout="prev, pager, next"
            :current-page="paginador.page"
            :page-count="paginador.nro_pages"
            :page-size="paginador.pageSize"
            @current-change="handlePageChange"
            :pager-count="5"
            hide-on-single-page
            ></el-pagination>
          </el-col>
        </el-row>
        <!-- Archivos -->
        <el-row>
          <el-col :span="24">
            <div class="card_list">
              <div v-if="loading" v-loading.lock="loading" class="loader"></div>
              <div v-else-if="archivos !== undefined && archivos.length > 0"
                  class="card_list_item"
                  v-for="archivo in archivos"
                  :key="archivo.id">
                  <ArchivoCard 
                  :archivo="archivo" 
                  :esBusqueda="true" 
                  @editar="editArchivo"
                  @borrarArchivo="mostrarMensajeEliminarArchivo"/>
              </div>
              <div v-else class="loader">{{$t('GENERAL_no_data')}}</div>
            </div>
          </el-col>
        </el-row>

        <!-- Paginador abajo -->
        <el-row style="margin-top:10px;">
          <el-col :xs="8" :sm="12" :md="10" :lg="16" :xl="16"></el-col>
          <el-col :xs="16" :sm="12" :md="14" :lg="8" :xl="8" class="pagination_container">
            <el-pagination
              background
              small
              layout="prev, pager, next"
              :current-page="paginador.page"
              :page-count="paginador.nro_pages"
              :page-size="paginador.pageSize"
              :pager-count="5"
              @current-change="handlePageChange"
              hide-on-single-page
            ></el-pagination>
          </el-col>
        </el-row>
        
      </el-col>
    </el-row>

    <AppDialog 
      :visible="id_archivo_eliminar !== undefined"
      :title="eliminar_archivo_titulo"
      :message="eliminar_archivo_mensaje"
      :onClose="onCloseEliminarConfirmation"
    />
  </div>
</template>


<script>
import ArchivoCard from "@/components/Cards/archivoCard";
import { mapState } from "vuex";
import AppDialog from "../Dialog";
import { mostrarMensajeInternacionalizado } from '../MensajeInternacionalizado/index'
import { showSuccess } from "../Mensaje"

let defaultPaginador = {
  page: 0,
  nro_pages: 1,
  pageSize: 20
};

let defaultFilters = {
  nombre: "",
  esArchivo: true,
  idCarpeta: -1,
  // incluirPublicos: false,
};

export default {
  name: "ArchivosList",
  components: { ArchivoCard, AppDialog},
  data() {
    return {
      archivos: [],
      carpetas: [],

      paginador: { ...defaultPaginador },
      filtros: { ...defaultFilters },
      activeNames: ["1"],
      loading: false,
      eliminar_archivo_mensaje: '',
      eliminar_archivo_titulo: '',
      id_archivo_eliminar: undefined
    };
  },
  computed: {
    ...mapState({
      idUsuario: state => state.sesion.resultadoAutenticacion.IdUsuario,
      ultimoFiltroAplicado: state => state.archivos.filtrosArchivos
    })
  },
  methods: {
    handlePageChange(page) {
      this.paginador.page = page;
      this.getArchivos();
    },
    seleccionarCarpeta()
    {
      this.paginador.page = 1;
      this.getArchivos();
    },
    getArchivos() {      
       // armo el payload
      //debugger;
      let payload = { 
        nombre: this.filtros.nombre,
        esArchivo: this.filtros.esArchivo,
        idCarpeta: (this.filtros.idCarpeta === -1)? undefined:this.filtros.idCarpeta,
        //idUsuario: this.idUsuario,
        page: this.paginador.page > 0 ? this.paginador.page - 1 : this.paginador.page,
        pageSize: this.paginador.pageSize
      }
      
      // guardo los últimos filtros aplicados
      this.$store.dispatch("archivos/setFiltrosArchivos", { ...payload });

      // indico que se están buscando los archivos
      this.loading = true;
      
      // busco los archivos
      this.$store.dispatch("archivos/getArchivos", payload)
      .then(data => {
        if (this.filtros.esArchivo) this.archivos = data.Result ? data.Result : [];
        else{
          this.archivos = data.Result ? data.Result : [];
          this.carpetas.length === 0 || this.filtros.nombre !== "" ? this.carpetas = this.archivos:null;
        } 
        this.paginador.nro_pages = data.Result ? data.TotalPages : 0;
      })
      .finally(() => (this.loading = false));
    },
    getArchivosDelayed() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      this.timer = setTimeout(() => {
        this.paginador = { ...defaultPaginador };
        this.getArchivos();
      }, 1000);
    },
    cleanFilters() {
      // limpio los filtros
      this.filtros = { ...defaultFilters };
      this.paginador = { ...defaultPaginador };

      // limpio los resultados de garantía
      this.archivos = [];

      this.getArchivos();
    },
    editArchivo(id_archivo) {
      this.$router.push({ path: `/archivos/edicion/${id_archivo}` });
    },
    mostrarMensajeEliminarArchivo(archivo_id,archivo_titulo,esArchivo)
    {
      if(esArchivo)
      {
        // armo el titulo del dialog
        this.eliminar_archivo_titulo = this.$t('ARCHIVOS_eliminar');
        // armo el mensaje a mostrar
        let mensaje = this.$t('ARCHIVOS_eliminar_mensaje');
        mensaje = mensaje.replace('[titulo]', archivo_titulo);
        this.eliminar_archivo_mensaje = mensaje;
      }
      else
      {
        // armo el titulo del dialog
        this.eliminar_archivo_titulo = this.$t('ARCHIVOS_eliminar_carpeta');
        // armo el mensaje a mostrar
        let mensaje = this.$t('ARCHIVOS_carpeta_eliminar_mensaje');
        mensaje = mensaje.replace('[titulo]', archivo_titulo);
        this.eliminar_archivo_mensaje = mensaje;
      }

      // guardo el archivo a eliminar
      this.id_archivo_eliminar = archivo_id;
    },
    onCloseEliminarConfirmation(confirm) 
    {
      // si confirmó el diálogo, elimino el archivo
      if(confirm)
      {
        this.borrarArchivo(this.id_archivo_eliminar);
      }
      
      // limpio los valores del diálogo
      this.id_archivo_eliminar = undefined;
      this.eliminar_archivo_mensaje = '';
      this.eliminar_archivo_titulo = '';
    },

    borrarArchivo(id_archivo)
    {
       this.$store.dispatch("archivos/eliminar", { id: id_archivo })
      .then(result => {
        if (result.CodigoResultado !== 0) mostrarMensajeInternacionalizado(
            result.CodigoResultado,
            result.DescripcionResultado
          );
        else 
        {
          showSuccess(this.$t("GENERAL_success"));
          this.getArchivos();
        }
      })
    }
  },
  mounted() {
    //Scroll para Android
       document.body.scrollTop = 0;
       //Scroll para IOS
       document.documentElement.scrollTop = 0;
    // verifico si se deben mantener los últimos filtros aplicados
    if (this.$route.params.keepFilter === true)
      this.filtros = { ...this.ultimoFiltroAplicado };

    // busco los archivos
    this.getArchivos();
  },
};
</script>

<style scoped>
.seleccionador {
    width: 100%;
    padding: 0;
}
.btn-nuevo {
  padding-right:0%;
  text-align:right;
}
.el-card {
  height: 100%;
}
.container {
  display: flex;
  min-height: 500px !important;
  width:  100% !important;
}

.pagination_container {
  text-align: right;
  padding-right:0px;
}

.container_col_1 .el-collapse,
.container_col_1 .el-collapse.el-collapse-icon-position-right {
  width: 100%;
}

@media (max-width: 600px) {
  .container {
    flex-direction: column;
  }
  .el-collapse.el-collapse-icon-position-right {
    width: 100%;
  }
  .container_col_1 {
    flex: 0 0 100% !important;
    width:100% !important;
    max-width:100% !important;
  }
  .container_col_2 {
    flex: 0 0 100% !important;
    width:100% !important;
    max-width:100% !important;
    margin-top:20px;
  }
}

.card_list {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  grid-gap: 1rem;
  width: 100%;
}
.card_list_item {
  position: relative;
}
.title {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  color: var(--main-color);
}
.sub-title {
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  color: #999;
}
.filters {
  display: flex;
  flex-direction: column;
}
.filters_item {
  flex: 1;
  margin-bottom: 10px;
}
.label {
  text-align: left;
  margin-bottom: 4px;
  font-size: 14px;
}
.switch {
  margin-left: 10px;
  margin-bottom: 2px;
}
.clearFilters {
  color: #5aabc6;
  font-size: 14px;
  text-align: left;
  margin-top: 10px;
  cursor: pointer;
}
.el-card__body {
  padding: 20px 40px;
}
.fade-enter-active {
  transition: opacity 0.5s;
}
.fade-leave-active {
  transition: opacity 0.1s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}


.el-radio-group {
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-top: 14px;
}
.el-radio {
  line-height: 2;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}

.loader {
  margin-top: 25%;
  color: #999;
}
</style>
